// library
import { ArSymbol } from '@aceroll/core/library';

// services
import { ArBitmapText, ArContainer, ArSprite, gameDispatcher, soundService } from '@aceroll/core';

export class Multiplier extends ArSymbol {
	#multContainer = null;
	#value = null;

	constructor() {
		super(...arguments);
		this.#createCounter(this.config.multiplier);

		this.spine.addEvent('3_rockets_eff', () => {//multAll
			gameDispatcher.emitStateless('multiplier_mult_all');
		});
		this.spine.addEvent('5_rockets_eff', () => {//addAll
			gameDispatcher.emitStateless('multiplier_add_all');
		});
		// this.spine.addEvent('fireworks', () => {//
		//     gameDispatcher.emitStateless('multiplier_mult');
		// });
		this.spine.addEvent('reel_eff', () => {
			gameDispatcher.emitStateless('reel_eff', {
				x: this.x,
				operation: this.config.multiplier.operation
			});
		});
	}

	#createCounter(config) {
		this.#multContainer = new ArContainer('Mult container');
		this.#multContainer.position.set(config.position.x, config.position.y);
		this.#multContainer.visible = false;

		const panel = this.#multContainer.addChild(ArSprite.from(config.panelAsset, 'Multiplier Panel'));
		panel.anchor.set(0.5);

		const value = ArBitmapText.from(config.bitmapFontName, config.operation + '2', 'Symbol Multiplier Value');

		value.anchor.set(0.5);
		value.style.fontSize = 84;
		value.style.letterSpacing = -80;
		value.position.set(-43, -10);

		this.#value = value;
		this.#multContainer.addChild(value);

		this.addChild(this.#multContainer);
	}

	async land() {
		return;
	}
	static() {
		super.static();

		this.#multContainer.visible = false;
	}

	async multiply(value=2, row=1) {
		const { sounds } = this.config.default;

		if (sounds.multiply) {
			soundService.play(sounds.multiply);
		}
		this.setValue(value);
		this.spine.speed = 1;
		await this.animate('row_' + row);
	}

	setValue(value) {
		this.#value.text = this.config.multiplier.operation + value;
		this.#multContainer.visible = true;
	}
}
